<script setup lang="ts">
import { type TService } from "@/assets/js/types";
// import { gsap } from "gsap";

type TProps = {
	services: TService[];
};
const props = defineProps<TProps>();

function backgroundStyle(service: TService) {
	if (service.bgImg)
		return {
			backgroundImage: `url(${service.bgImg})`, // set bg image
			backgroundSize: "cover",
			backgroundPosition: "center",
		};
}

const sliderWrapper = ref();

// function navigate(direction: string) {

// 	let el = sliderWrapper.value;
// 	const step = document.querySelector<HTMLDivElement>(".wrapp-slider");
// 	let itemWidth = step?.offsetWidth ?? 500;

// 	if (direction === "right") {
// 		el.scrollLeft += itemWidth; // itemWidth * (itemsShown - 1);
// 	} else {
// 		console.log(itemWidth);
// 		el.scrollLeft -= itemWidth; // itemWidth * (itemsShown - 1);
// 	}
// }

const currentIndex = ref(0);
const lastIndex = computed(() => props.services.length - 1);

const isFirst = computed(() => currentIndex.value === 0);
const isLast = computed(() => currentIndex.value === lastIndex.value);

const nextIndex = computed(() =>
	isLast.value ? lastIndex.value : currentIndex.value + 1,
);

const prevIndex = computed(() => (isFirst.value ? 0 : currentIndex.value - 1));

function navigate(direction: string) {
	let el = sliderWrapper.value;
	const step = document.querySelector<HTMLDivElement>(".wrapp-slider1");
	let itemWidth = step?.offsetWidth ?? 500;
	// *** Nav ***
	if (direction === "right") {
		el.scrollLeft = nextIndex.value * itemWidth;
		currentIndex.value = nextIndex.value;
	} else {
		el.scrollLeft = prevIndex.value * itemWidth;
		currentIndex.value = prevIndex.value;
	}

	// ***  indeks ***
	//  currentIndex.value = Math.round(el.scrollLeft / itemWidth);
}
// // const isMobile = ref(false);
// function onResize() {
//     // if (window.innerWidth <= 768) {
//     //     console.log("is mobile true ");
//     //     isMobile.value = true;
//     // } else {
//     //     console.log("is mobile false ");
//     //     isMobile.value = false;
//     // }

// }

// onMounted(() => {
//     // onResize();
//     window.addEventListener("resize", onResize);
// });
// onUnmounted(() => {
//     window.removeEventListener("resize", onResize);
// });
const preventTouch = (e: TouchEvent) => {
	e.preventDefault();
};
onMounted(() => {
	const el = sliderWrapper.value;

	el.addEventListener("touchmove", preventTouch, { passive: false });
});
onUnmounted(() => {
	const el = sliderWrapper.value;
	el.removeEventListener("touchmove", preventTouch);
});
const height = ref(312); // min value of open content
const offsetArrow = computed(() => {
	return `top:${67 + height.value / 2 - 40}px`;
	// 67px padding on  .bg div(one service) , 20 icon
});
</script>
<template>
	<div
		class="wrapp-slider1"
		:style="backgroundStyle(props.services[currentIndex])"
	>
		<div ref="sliderWrapper" class="wrapp-services-slide">
			<div
				v-for="(service, index) in props.services"
				:key="index"
				class="one-service1"
				:class="{
					previous: prevIndex === index && prevIndex !== currentIndex,
					next: nextIndex === index && nextIndex !== currentIndex,
				}"
			>
				<!-- !isMobile ||currentIndex === index ? backgroundStyle(service):'' -->
				<div class="bg">
					<div class="content-open">
						<h2 class="title animationSet">{{ service.title }}</h2>
						<div class="wrapp-txt">
							<div
								v-for="(value, index1) in service.text"
								:key="index1"
								class="txt animationSet"
							>
								{{ value }}
							</div>
						</div>

						<a
							v-if="service.link.startsWith('http')"
							:href="service.link"
							target="_blank"
							class="animationSet"
							>See more <img src="@/assets/images/arrow_insert.svg" alt="" />
						</a>
						<router-link
							v-else
							class="animationSet"
							:to="{ name: service.link }"
						>
							See more <img src="@/assets/images/arrow_insert.svg" alt="" />
						</router-link>
					</div>
				</div>
			</div>
		</div>

		<div
			class="arrowSlide left"
			:class="{ disabled: isFirst }"
			:style="offsetArrow"
			@click="navigate('left')"
		>
			<img src="@/assets/images/backgroundServices/arrow_left.svg" alt="<" />
		</div>
		<div
			class="arrowSlide right"
			:class="{ disabled: isLast }"
			:style="offsetArrow"
			@click="navigate('right')"
		>
			<img src="@/assets/images/backgroundServices/arrow_right.svg" alt=">" />
		</div>
		<div class="wrapp-bg-img">
			<img
				class="bg-img"
				:class="{ rotate90: currentIndex === 1, rotate180: currentIndex === 2 }"
				src="@/assets/images/backgroundServices/light.png"
			/>
		</div>
	</div>
</template>
<style lang="scss" scoped>
.wrapp-slider1 {
	box-sizing: border-box;
	display: flex;
	height: 100%;
	width: 100%;
	transition: transform 0.3s ease;
	position: relative;
	overflow: hidden;
	text-align: center;
}

.wrapp-bg-img {
	position: absolute;
	left: 0%;
	top: 0%;
	width: 100%;
	height: 100%;
	overflow: hidden;

	.bg-img {
		position: absolute;
		left: -150%;
		top: 0%;
		width: 400%;
		transition: transform 0.3s ease;
	}
	.rotate90 {
		transform: rotate(-90deg);
		transform-origin: center;
	}
	.rotate180 {
		transform: rotate(-180deg);
		transform-origin: center;
	}
}
.wrapp-services-slide {
	display: flex;
	max-height: 100%;
	// background-color: #000203af;
	background: #53aa6c;
	// background: linear-gradient(
	//     180deg,
	//     rgba(0, 0, 0, 0.42) 0%,
	//     rgba(0, 0, 0, 0.56) 100%
	// );
	background: linear-gradient(
		180deg,
		rgba(0, 0, 0, 0.6) 0%,
		rgba(0, 0, 0, 0.8) 100%
	);
	box-sizing: border-box;
	// z-index: 100;
	// height: calc(100% - 100px);
	width: 100%;
	// overflow: auto;

	overflow-y: hidden;
	scroll-behavior: smooth;
	-ms-overflow-style: none; /* IE and Edge */
	scrollbar-width: none;
	overflow-x: hidden;
	touch-action: none;
}

.one-service1 {
	box-sizing: border-box;
	height: 100%;
	// display: flex;
	// justify-content: center;
	// align-items: center;
	font-family: Archivo, sans-serif;
	position: relative;
	overflow: hidden;
	min-width: 100% !important;
	width: 100% !important;
	max-height: 100% !important;
	transition: transform 0.3s ease-in-out;
	// transform: rotate(0deg) translateY(0%);
	z-index: 2;
}
.previous {
	transform: rotate(-20deg) translateY(15%);
	z-index: 1;
}
.next {
	transform: rotate(20deg) translateY(15%);
	z-index: 1;
}
.one-service1.open {
	transform: rotate(330deg);
}

.bg {
	width: 100%;
	display: flex;
	justify-content: center;
	box-sizing: border-box;
	// padding: 67px 40px 150px;
	padding: 67px 40px 0;
	align-items: flex-start;
	height: 100%;
}
.content-open {
	margin: 0 20px;
	width: 580px;
	min-height: 312px;
	opacity: 1;
	gap: 32px;
	border-radius: 32px;
	padding: 32px;
	// background: #ffffff14;
	// background: linear-gradient(90deg, #ffffff14 0%, #c6cbc93a 100%);
	background: linear-gradient(90deg, #ffffff03 0%, #c6cbc91f 100%);
	backdrop-filter: blur(4.3px) !important;
	border: 1px solid rgba(255, 255, 255, 0.3);
	.title {
		font-weight: 700;
		font-size: 40px;
		line-height: 100%;
		letter-spacing: 0%;
		margin-top: 0;
		margin-bottom: 32px;
	}
	.wrapp-txt {
		.txt {
			font-family: Poppins, sans-serif;
			font-weight: 400;
			font-size: 20px;
			line-height: 110%;
			letter-spacing: 0%;
			margin-bottom: 16px;
		}
		.txt:last-of-type {
			margin-bottom: 0;
		}
	}
	a {
		margin-top: 32px;
		background: linear-gradient(90deg, #6cc986 0%, #4bba9b 100%);
		width: fit-content;
		height: 42px;
		opacity: 1;
		border-radius: 38px;
		padding: 10px 12px;
		gap: 5px;
		display: flex;
		align-items: center;
		color: #fff;
	}
}
.content-default {
	margin: 0 20px;
	font-weight: 400;
	font-size: 28px;
	line-height: 100%;
	letter-spacing: 0%;
}
.disabled {
	opacity: 0.4;
}
.arrowSlide {
	display: initial;
	position: absolute;
	cursor: pointer; // top:calc(50% - 20px);
	z-index: 11;
	padding: 20px 0;
	top: calc(
		67px + 160px - 20px
	); // 321/2 = 160 min height of open content div, 67- padding bg div, 20 icon
	// img {
	// 	width: 11px;
	// }
}

.arrowSlide.left {
	left: 15px;
	padding-right: 30px;
}
.arrowSlide.right {
	right: 15px;
	padding-left: 30px;
}

@media screen and (width <=768px) {
	.content-open {
		margin: 0;
		// height: 403px;
		height: fit-content;
		display: flex;
		flex-direction: column;
		gap: 0;
		.title {
			font-size: 22px;
		}
		.wrapp-txt {
			.txt {
				font-size: 16px;
				line-height: 110%;
				margin-bottom: 16px;
			}
			.txt:last-of-type {
				margin-bottom: 30px;
			}
		}
		a {
			margin-top: auto;
			align-self: flex-end;
			font-weight: 500;
			font-size: 16px;
			line-height: 100%;
			letter-spacing: 0%;
			padding: 8px 10px;
			height: fit-content;
			background: linear-gradient(
				90deg,
				rgba(108, 201, 134, 0.34) 0%,
				rgba(75, 186, 155, 0.34) 100%
			);
		}
	}
}
</style>
